import { RequestTypes } from 'legacy/lut/classes/models/onboarding/Onboarding'

import { onboardingTemplateApi } from 'onboarding/classes/services/api/OnboardingTemplateApi'

import { onboardingRequestDetailApi } from '../api/OnboardingRequestDetailApi'

class TemplateService {
  public fetchRequestTemplate = (templateUUID: string) => {
    return onboardingRequestDetailApi.getRequestTemplate(templateUUID)
  }

  public fetchRequestTemplateByRequestId = (requestId: number) => {
    return onboardingTemplateApi.getRequestTemplateByRequestId(requestId)
  }

  public fetchAvailableCountriesByRequestType = (requestType: RequestTypes) => {
    return onboardingTemplateApi.getAvailableCountriesByRequestType(requestType)
  }
}

export const templateService = new TemplateService()
